import React from "react"
import Slider from "react-slick"

function SimpleSlider({ children }) {
  return (
    <Slider
      infinite={true}
      arrows={false}
      autoplay={true}
      autoplaySpeed={5000}
      dots={true}
      slidesToShow={1}
      slidesToScroll={1}
    >
      {children}
    </Slider>
  )
}

export default SimpleSlider
